import React, { useEffect } from 'react';

import { InfoMessage } from '@eika/attention-message';
import { MediumCenteredContainer } from '@eika/engine-view';
import { IconTypes } from '@eika/icon';

import { StringKeyValue } from '../../actions/types';
import { ContextReducer } from '../../reducers/context';
import { LbsReducer } from '../../reducers/lbs';
import { SigningReducer } from '../../reducers/signing';
import { UserReducer } from '../../reducers/user';
import ErrorMessage from '../Messages/ErrorMessage';
import BankIDSign from './BankIDSign';

interface Props {
    text: StringKeyValue;
    user: UserReducer;
    signing: SigningReducer;
    context: ContextReducer;
    lbs: LbsReducer;
}

const SigningComponent = (props: Props): JSX.Element => {
    const { text, signing, user, context, lbs } = props;
    const { signingHeader, signingInfoBox, signingInfoBox2 } = text;
    const { signingUrl } = signing;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    let signering;

    if (!signingUrl) {
        signering = (
            <ErrorMessage
                title={text.serviceErrorHeader}
                textList={[text.serviceErrorText1, text.serviceErrorText2]}
                useWrapper={false}
            />
        );
    } else {
        signering = <BankIDSign url={signingUrl || ''} context={context} lbs={lbs} user={user} text={text} />;
    }

    return (
        <div className="signing">
            <MediumCenteredContainer>
                <>
                    {signingHeader && <h1 className="page-header">{signingHeader}</h1>}
                    {signering}
                    {signingInfoBox && (
                        <InfoMessage
                            icon={IconTypes.LYSPAERE_24}
                            text={signingInfoBox}
                            clickableItem={<>{signingInfoBox2}</>}
                        />
                    )}
                </>
            </MediumCenteredContainer>
        </div>
    );
};

export default SigningComponent;
